import { create } from "zustand";

import type {
  DeviceSessionVO,
  HeartbeatResponse,
} from "@eweadn-qiankun/shared-http";

export type DeviceSessionRole = "owner" | "standby" | "offline";

export interface DeviceSessionPresenceState {
  role: DeviceSessionRole;
  sessionId: string | null;
  deviceKey: string | null;
  ownerSessionId: string | null;
  ownerClientType: "web" | "desktop" | null;
  conflicts: DeviceSessionVO[];
  lastHeartbeat: HeartbeatResponse | null;
  isPresenceActive: boolean;
  setPresence: (patch: Partial<DeviceSessionPresenceState>) => void;
  resetPresence: () => void;
}

const initialState = {
  role: "offline" as DeviceSessionRole,
  sessionId: null,
  deviceKey: null,
  ownerSessionId: null,
  ownerClientType: null,
  conflicts: [] as DeviceSessionVO[],
  lastHeartbeat: null,
  isPresenceActive: false,
};

export const useDeviceSessionPresenceStore = create<DeviceSessionPresenceState>(
  (set) => ({
    ...initialState,
    setPresence: (patch) => set((s) => ({ ...s, ...patch })),
    resetPresence: () => set({ ...initialState }),
  })
);

export const DEVICE_SESSION_PRESENCE_CHANGED_EVENT =
  "eweadn:deviceSessionPresenceChanged";

export function notifyDeviceSessionPresenceChanged(): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(DEVICE_SESSION_PRESENCE_CHANGED_EVENT));
}
